/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { Document, Page } from 'react-pdf';
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import Lightbox from 'react-image-lightbox';
import { API_URL, downloadFile, getFileContent } from"../../network"
import Moment from 'react-moment';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import classnames from 'classnames';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';





function Index(props) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tooltipStatus, setTooltipStatus] = useState(false);
  const [tooltipValid, setTooltipValid] = useState(false);
  const [modalImage, setModalImage] = useState(false)
  const [openProductImage, setOpenProductImage] = useState(false)
  const [logOpen, setLogOpen] = useState(false)
  const [logData, setLogData] = useState("")

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(0.8)
  const [pdfRotate, setPdfRotate] = useState(0)
  const [curSrc, setCurSrc] = useState(null);
  const [openPreview, setOpenPreview] = useState(false)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const fileRef = useRef(null);

  const toggleTooltipStatus = () => setTooltipStatus(!tooltipStatus);
  const toggleTooltipValid = () => setTooltipValid(!tooltipValid);

  useEffect(() => {
    getData();
  },[props.selectedUser,props.selectedContact]);

  const showProductImage = (item)=>{    
    axios.get(`/quotes/logo/${item['id']}`).then(res => {
      setOpenProductImage(true)
        setModalImage('data:image/png;base64, '+res.data)
    })    
  }

  const viewLog = (id)=>{
    axios.get(`/quotes/getlog/${id}`).then(res => {
      setLogOpen(true)
      setLogData(res.data)
    })    
  }
  
  const toggleProductImage = () => {
    console.log("toggle");
    setOpenProductImage(!openProductImage);
  }


  const getData = ()=>{
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    // if(!props.selectedUser && role=="admin"){
    //   setTableData([]); return;
    // }
    axios.get(`/quotes/index?userid=${props.selectedUser?props.selectedUser:''}&contactid=${props.selectedContact?props.selectedContact:''}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        setTableData(res.data.data);
      
      setLoading(false)
    })    
  }
  const token = localStorage.getItem('token_bigbrand');    
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }
  
  const submitReady = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('ready', value?1:0);
    setLoading(true)

    axios.post(`/quotes/setready/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        getData(true);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }


  const submitSent = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('sent', value?1:0);
    setLoading(true)

    axios.post(`/quotes/setsent/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        getData();
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  var extension = 'pdf';

  return (
    <>    
    <Row className="mt-4">
        <Col md="12">
          <Table className="mt-3" striped >  
            <thead>
              <tr>
                <th></th>
                <th>No.</th>
                <th>Name</th>
                <th>Description</th>
                <th>
                  <div className="d-flex align-items-center justify-content-center">
                    <span>Status</span>
                    <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipStatus" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipStatus} className="text-left" target="tooltipStatus" toggle={toggleTooltipStatus}>
                      Status<br/>
                    </Tooltip>
                  </div>
                </th>
                {/* <th>Created</th> */}
                <th>
                  <div className="d-flex align-items-center justify-content-center">
                    <span>Valid Until</span>
                    <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipValid" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipValid} className="text-left" target="tooltipValid" toggle={toggleTooltipValid}>
                      valid until<br/>
                    </Tooltip>
                  </div>
                </th>
                <th>History</th>
                <th>Total</th>
                {role=='admin' &&
                <th>Ready/<br/>Review</th>
                }
                {role=='admin' &&
                <th>Sent</th>
                }
                <th>View</th>
              </tr>
            </thead>               
            <tbody>
              {
                tableData.map((row, index)=>{
                  return (
                    <tr>
                      <td width="50px" className="pl-2 pr-2" scope="row">
                        <span style={{cursor:"pointer"}} onClick={async ()=>{let pdfUrl = await getFileContent(`/quotes/quotepdf1/${row['id']}`); setCurSrc(pdfUrl); setOpenPreview(true)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                      </td>
                      <td>
                        #{row['id']}
                      </td>
                      <td>
                        {(row['label']?row['label']:"")+(row['revision']?(" - R"+row['revision']):"")}
                      </td>
                      <td>
                        {row['client_label']}
                      </td>
                      <td className="pl-2 pr-2">
                        {row['status']}
                      </td>
                      {/* <td className="pl-2 pr-2">
                        {row['updated_at']}
                      </td> */}
                      <td className="pl-2 pr-2">
                        {row['valid_to']?                  
                          <Moment format="DD/MM/YYYY">
                            {row['valid_to']}
                          </Moment>
                          :""
                        }
                      </td>
                      <td className="pl-2 pr-2">
                        <Button size="sm"
                          onClick={()=>{viewLog(row['id'])}} outline
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text">View</span>
                        </Button>
                      </td>
                      <td className="pl-2 pr-2">
                      ${row['price']?(row['price']+row['price']/10).toFixed(2):0}
                      </td>
                      {role=='admin' &&
                      <td className="pl-2 pr-2">
                        <div className="custom-control custom-control-alternative custom-checkbox">
                          <input
                            className="custom-control-input"
                            id={`customCheckReady${index}`}
                            type="checkbox"
                            checked={row['ready']}
                            onChange={()=>submitReady(row['id'], !row['ready'])}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`customCheckReady${index}`}
                          >
                            <span></span>
                          </label>
                        </div>
                      </td>
                      }
                      {role=='admin' &&
                      <td className="pl-2 pr-2">
                        <div className="custom-control custom-control-alternative custom-checkbox">
                          <input
                            className="custom-control-input"
                            id={`customCheckSent${index}`}
                            type="checkbox"
                            checked={row['sent']}
                            onChange={()=>submitSent(row['id'], !row['sent'])}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`customCheckSent${index}`}
                          >
                            <span></span>
                          </label>
                        </div>
                      </td>
                      }
                      <td>                        
                        <Button size="sm"
                          onClick={()=>role=='admin'?props.history.push(("/admin/requests/edit/")+row['id']):props.history.push(("/requests/edit/")+row['id'])}
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text">View</span>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>
      <LoadingOverlay
        active={loading}
        styles={{
            overlay: (base) => ({
            ...base,
            fontSize:'18px',
            color: 'rgb(5, 37, 51)',
            background: 'rgb(60 60 60 / 48%)',
            position:'fixed',
            zIndex:1000000000
            })
        }}
        spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
        // spinner
        // text='Loading ...'
        >
      </LoadingOverlay>
      {openProductImage && (
        <Lightbox
          mainSrc={modalImage?modalImage:require("assets/img/theme/product-placeholder.jpg")}
          
          onCloseRequest={() => toggleProductImage()}
        />
      )} 

      <Modal isOpen={openPreview} toggle={()=>setOpenPreview(false)} >
        <ModalHeader toggle={()=>setOpenPreview(false)}>Preview</ModalHeader>
        <ModalBody>          
          <div className="resource-preview-container">
            <div className="resource-preview">
              {extension && ( extension.toLowerCase().includes("jpg") || extension.toLowerCase().includes("png") || extension.toLowerCase().includes("jpeg") || extension.toLowerCase().includes("gif") ) &&
                <InnerImageZoom src={curSrc} zoomSrc={curSrc} /> 
              }
              {extension && ( extension.includes("pdf")) &&
              <div>
                <Document file={curSrc} onLoadSuccess={onDocumentLoadSuccess}>
                  <Page scale={pdfScale} pageNumber={pageNumber}  rotate={pdfRotate}/>
                </Document>
              </div>
              }
            </div>
            {curSrc &&extension && ( extension.includes("pdf")) &&
            <div className="d-flex justify-content-between">
              <a href={curSrc} download target="_blank" ><i className="fa fa-folder-open"></i></a>
              <div>
                <i className="fa fa-search-minus mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfScale(pdfScale*0.8)}}></i>
                <i className="fa fa-search-plus mr-3" style={{cursor:'pointer'}} onClick={()=>{ setPdfScale(pdfScale*1.2)}}></i>
                <i className="fa fa-rotate-left mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfRotate((pdfRotate-90)%360)}}></i>
                <i className="fa fa-rotate-right mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfRotate((pdfRotate+90)%360)}}></i>
                <i className="fa fa-chevron-left mr-3" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber>1) setPageNumber(pageNumber-1)}}></i>
                <span className="mr-3" style={{fontSize:14}}>Page {pageNumber} of {numPages}</span>
                <i className="fa fa-chevron-right" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber<numPages) setPageNumber(pageNumber+1)}} ></i>
              </div>
            </div>
            }
          </div>
        </ModalBody>
      </Modal>
      
      <Modal isOpen={logOpen} toggle={()=>setLogOpen(false)} >
        <ModalHeader toggle={()=>setLogOpen(false)}>History</ModalHeader>
        <ModalBody style={{whiteSpace:'pre-line'}}>
          {logData}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" size="sm" onClick={()=>setLogOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
